import { FinancialConfig } from '@futrli-sdk/predict';

/**
 * Return true if the given financial config indicates that the org uses french accounting rules
 * @param financialConfig - Financial config of the organisation
 */
export const hasFrenchAccountingRules = (financialConfig: FinancialConfig | undefined) => {
  return financialConfig?.accounting_rules === 'french';
};

/**
 * Return true if the given financial config indicates that Google Sheets imports are allowed
 * @param financialConfig - Financial config of the organisation
 * @returns boolean indicating if Google Sheets imports are allowed
 */
export const hasAllowedGoogleSheetsImports = (financialConfig?: FinancialConfig) => {
  return financialConfig?.allow_google_sheet_import === true;
};
